import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent, actionNames } from "@newsela/snitch";
import { buttonMarginCss } from "../Actions.style";
import getButtonProps from "../utils/getButtonProps";
import useEventProperties from "../utils/useEventProperties";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  annotationId: PropTypes.number,
  isActionPending: PropTypes.bool,
  handleShare: PropTypes.func,
  isShared: PropTypes.bool,
  hasReplies: PropTypes.bool,
};
const ShareButton = ({
  annotationId,
  isActionPending,
  handleShare,
  isShared,
  hasReplies,
}) => {
  const description = isShared ? "Unshare annotation" : "Share annotation";
  const buttonFlavor = isShared ? "flat" : "solid";
  const eventProperties = useEventProperties(
    annotationId,
    actionNames.share,
    description,
  );

  return (
    <ButtonWithTrackEvent
      __cssFor={{ root: buttonMarginCss }}
      dataProps={{
        "data-qa-selector": isShared
          ? "unshare-annotation"
          : "share-annotation",
      }}
      disabled={(isShared && hasReplies) || isActionPending}
      onClick={handleShare}
      {...getButtonProps(buttonFlavor)}
      {...eventProperties}
    >
      {isShared ? "Unshare" : "Share"}
    </ButtonWithTrackEvent>
  );
};

ShareButton.propTypes = propTypes;

export default ShareButton;
